import { render, staticRenderFns } from "./carduizhang.vue?vue&type=template&id=37b366db&scoped=true&"
import script from "./carduizhang.vue?vue&type=script&lang=js&"
export * from "./carduizhang.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=37b366db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b366db",
  null
  
)

export default component.exports